import React from 'react';
import classNames from 'classnames/bind';
import { Radio } from '../Radio';

import css from './radio-group.module.css';

const cx = classNames.bind(css);

type RadioGroupDataItem = {
  id: string | number;
  label: string;
};

type Props = {
  items: RadioGroupDataItem[];
  onChange?(id: string | number): void;
  selected: string;
  maxPerLine: number;
  className?: string;
  rowClassName?: string;
  disabled?: boolean;
};

export const RadioGroup: React.FC<Props> = props => {
  const {
    items,
    onChange,
    maxPerLine = Number.POSITIVE_INFINITY,
    rowClassName,
    selected,
    className,
    disabled = false,
  } = props;

  const rows: Array<RadioGroupDataItem[]> = [];
  let currentRow = [];

  for (const [index, item] of items.entries()) {
    if (index % maxPerLine === 0) {
      currentRow = [];
      rows.push(currentRow);
    }

    currentRow.push(item);
  }

  return (
    <div className={cx('radio-group', className)}>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className={cx('row', rowClassName)}>
          {row.map(item => (
            <Radio
              disabled={disabled}
              key={item.id}
              id={String(item.id)}
              label={item.label}
              checked={item.id === selected}
              onChange={() => onChange?.(item.id)}
              value={item.id}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
